var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layer"},_vm._l((_vm.layer.elements),function(element){return _c('app-element',{key:element.id,attrs:{"element":element,"templateOverrides":_vm.templateOverrides,"pageWidth":_vm.pageWidth,"pageHeight":_vm.pageHeight}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }